<template>
  <div class="rule">
    <div class="table">
      <div class="table-total">共{{ list.length }}条数据</div>
      <el-table
        :border="false"
        :data="list"
        ref="table"
        :max-height="tableHeight"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
      >
        <el-table-column
          v-for="item in ruleColumn"
          :prop="item.key"
          :label="item.name"
          :key="item.id"
          :width="item.width"
          :fixed="item.fixed"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row[item.key] || "--" }}
            <svg-icon
              v-if="scope.row.warnDetailName && item.key === 'warnDetailName'"
              :iconClass="(statusList.find((item) => item.label === scope.row.warnDetailName) || {}).key"
              className="icon"
            ></svg-icon>
          </template>
        </el-table-column>
        <el-table-column align="right" prop="operate" key="operate" label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" :class="{ 'un-related': scope.row.isBindEmail }" @click="relateEmail(scope.row)">
              {{ scope.row.isBindEmail ? "解绑邮箱" : "关联邮箱" }}
            </el-button>
            <el-button type="text" @click="viewEmail(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog lock-scroll :visible.sync="dialogVisible" width="393px" :close-on-click-modal="false">
      <template slot="title"><span class="title">已关联邮箱</span></template>
      <div class="form-wrap">
        <el-input placeholder="搜索邮箱" suffix-icon="el-icon-search" v-model="email"> </el-input>
        <div class="detail">
          <div v-if="emailList.length === 0">暂未关联邮箱</div>
          <div v-else v-for="item in emailList.filter((item) => item.match(new RegExp(email)))" :key="item" class="email">{{ item }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ruleColumn, statusList } from "../config";
import SvgIcon from "@/components/SvgIcon.vue";
import { bindWarnEmail, unbindWarnEmail } from "@/api/api";
export default {
  components: {
    SvgIcon,
  },
  props: {
    list: Array,
  },

  data() {
    return {
      statusList,
      ruleColumn,
      loading: false,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableHeight: window.innerHeight - 305,
      dialogVisible: false,
      email: "",
      emailList: [],
    };
  },

  computed: {},

  watch: {},

  methods: {
    viewEmail(data) {
      this.emailList = data.emails ? data.emails.split(",") : [];
      this.dialogVisible = true;
    },
    relateEmail(data) {
      const { isBindEmail, id } = data;
      if (isBindEmail) {
        this.$confirm("是否确定解绑该邮箱", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            unbindWarnEmail({ id }).then((res) => {
              if (res.code === "0000") {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.$emit("successCallBack");
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消解绑",
            });
          });
      } else {
        bindWarnEmail({ id }).then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$emit("successCallBack");
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.rule {
  padding-bottom: 16px;
  .table-total {
    color: #000000d9;
    font-weight: bold;
    font-size: 14px;
    margin: 12px 0;
  }
  .title {
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
  }
  .un-related {
    color: #eb3131;
  }
  .icon {
    font-size: 10px;
    margin-left: 4px;
    margin-bottom: 1px;
  }
  .form-wrap {
    padding-bottom: 24px;
    width: 329px;
    .detail {
      height: 306px;
      border-radius: 4px;
      border: 1px solid #e6e6e6;
      background: #f8f8f8;
      box-shadow: 0px 2px 12px #0000001f;
      margin-top: 8px;
      padding: 16px 16px 0 16px;
      overflow-y: overlay;
      .email {
        color: #000000a6;
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
